import { render, staticRenderFns } from "./AdminReportInfo.vue?vue&type=template&id=1090d891"
import script from "./AdminReportInfo.vue?vue&type=script&lang=js"
export * from "./AdminReportInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports